import React, { useState } from 'react'
import { useInfiniteQuery } from 'react-query'

import { client } from '@client/init'
import { SortByType, SortingType } from '@components/Table/interface'
import { PromotionListProps, WithPromotionListProps } from './interface'

export function withPromotionList(Component: React.FC<PromotionListProps>) {
  function WithPromotionList({ bookId, searchParams }: WithPromotionListProps) {
    const [sort, setSort] = useState<SortByType>({
      key: 'revenue',
      order: SortingType.DESC,
    })

    function handleSort({ key, order }: SortByType) {
      setSort(prev => ({ ...prev, key, order }))
    }

    const { fetchNextPage, data, isLoading, isFetchingNextPage } =
      useInfiniteQuery(
        ['book-promotion-detail-dashboard', bookId, sort, searchParams],
        ({ pageParam = 1 }) =>
          client?.storyClient.getBookPromotionDetailDashboard({
            bookId: Number(bookId),
            page: pageParam,
            startDate: searchParams.startDate,
            endDate: searchParams.endDate,
            ...sort,
          }),
        {
          enabled: !!bookId && !!searchParams,
          getNextPageParam: lastPage => {
            if (lastPage && lastPage.data.length) {
              return lastPage.page + 1
            }

            return undefined
          },
        }
      )

    function handleFetchNextPage() {
      if (!isFetchingNextPage) fetchNextPage()
    }

    const newProps = {
      data,
      isLoading,
      sort,
      handleSort,
      handleFetchNextPage,
    }

    return <Component {...newProps} />
  }

  return WithPromotionList
}
